'use client';

import { useMutation } from '@tanstack/react-query';
import { PAYMENT_MUTATIONS } from '../../infrastructure/payment/utils/queries';

export const usePaymentService = () => {
  const useCreatePaymentIntent = () => {
    return useMutation(PAYMENT_MUTATIONS.createPaymentIntent());
  };

  const useUpdatePaymentIntent = () => {
    return useMutation(PAYMENT_MUTATIONS.updatePaymentIntent());
  };

  return {
    useCreatePaymentIntent,
    useUpdatePaymentIntent,
  };
};
